import React, { Component } from 'react';
import Faq from './Faq.js';

class FaqList extends Component { 
    constructor(props){
      super(props);
      this.state = {
      };
      this.openTarget = this.getUrlParam('open');
      this.getUrlParam = this.getUrlParam.bind(this);
    }

    componentDidMount = () => {
      if (!!this.openTarget) {
        const targetHeight = document.getElementById(this.openTarget).childNodes[0].offsetTop - 80;
        window.scrollTo(0, targetHeight);
      }
    };

    getUrlParam = (key) => {
      const reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(decodeURI(r[2])); return '';
    };

    render() {
      let data = this.props.groups;

      const listItem = data.map((item,key)=>{
          return (
            <div className={'faq-group-container'} id={'groupIndex_'+key} key={key}>
                <h3 className="faq-group-title" data-Key={"groupTitle_"+key}>{item.groupTitle}</h3>
                {
                  item.questions.map((q,index)=>{
                    const currentId = 'list_'+(key+1)+'_'+q.index;
                    const isOpen = currentId===this.openTarget;
                    return <Faq key={q.title+index} index={"questionTitle"+index} title={q.title} content={q.content} isOpen={isOpen} currentId={currentId} />
                  })
                }
            </div>        
          ) 
      });
      return (
        <div>
          {listItem}
        </div>
      );
    }
}

FaqList.defaultProps = {
    questions:[]
};

export default FaqList;



// WEBPACK FOOTER //
// ./src/shared/Faq/components/FaqList.js